import React, { useContext } from 'react';
import { ChevronLeft } from 'react-bootstrap-icons';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

import AppContext from '../../../context';
import { resetPortfolio } from '../../../../api';
import {
  KiteIcon,
  AngelBrokingIcon,
  UpstoxIcon,
  GrowwIcon,
} from '../../../../assets/icons';

const SwitchToBroker = (props) => {
  const context = useContext(AppContext);
  const { pfId, onBack, setContext, setStep } = props;
  const pf = context.portfoliosById[pfId];

  const onClearPortfolio = async () => {
    try {
      const response = await resetPortfolio(pfId);
      let pfs = _.cloneDeep(context.portfolios);
      const pfIdx = context.portfolios.findIndex((_pf) => _pf.id == pfId);
      if (pfs[pfIdx].has_mfs) {
        pfs[pfIdx].has_equity_or_etf = false;
        setContext({ portfolios: pfs });
      } else {
        pfs[pfIdx] = {
          id: pfs[pfIdx].id,
          name: pfs[pfIdx].name,
          is_empty: true,
        };
        setContext({
          portfolios: pfs,
          resetPf: { resetId: pfId, switchId: pfs[1].id },
        });
      }
      setStep('empty_pf');
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <section className="add-tx-content">
        <div className="add-tx-header position-relative px-md-5 pt-md-5 px-sm-4 pt-sm-4 px-4 pt-4">
          <span className="step-text">{pf.name}</span>
          <h5 className="step-heading pt-1">CONVERT TO BROKER SYNCED</h5>
        </div>
        <div className="switch_to_broker py-0">
          <h4 className="content-heading">
            Convert to Broker Synced Portfolio
          </h4>
          <div className="info_bar mb-4">
            <FontAwesomeIcon icon={faExclamationCircle} />
            Clear your current portfolio to enable broker connect
          </div>
          <p>Instantly pull your data</p>
          <p>All features except IRR and Sharpe ratio</p>
          <div className="brokers mt-2">
            <div>
              <img src={KiteIcon} alt="zerodha" />
              <div>Zerodha</div>
            </div>
            <div>
              <img src={AngelBrokingIcon} alt="angel one" />
              <div>Angel One</div>
            </div>
            <div>
              <img src={UpstoxIcon} alt="upstox" />
              <div>Upstox</div>
            </div>
            <div>
              <img src={GrowwIcon} alt="groww" />
              <div>Groww</div>
            </div>
          </div>
          <div className="more mt-1">+4 More</div>
          <Button
            variant="danger"
            type="button"
            className="action-btn my-3"
            onClick={() => onClearPortfolio()}
          >
            Clear Stock Portfolio & Proceed
          </Button>
        </div>
      </section>
      <div className="modal-footer">
        <button
          type="button"
          className="mr-auto back-button btn btn-sm"
          onClick={onBack}
        >
          <ChevronLeft /> <span>Back</span>
        </button>
      </div>
    </>
  );
};

export default SwitchToBroker;
